import { ApiResponse, ReferralResponse } from "../../../types";
import { getRequestWithAuth } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";


const api = getApiWithVersion(API_VERSION.V1);

export interface ReferralApiWrapper {
  success: boolean;
  data: ReferralResponse;
}

export interface API_Referral {
  fetchReferrals(user_id: number): Promise<ApiResponse<ReferralApiWrapper>>;
}

const referral: API_Referral = {
  fetchReferrals(user_id) {
    return getRequestWithAuth(api.FETCH_REFERRAL, user_id);
  }
};

export default referral;
